const elms = document.querySelectorAll('.wp-block-dunesblocks-faq');
elms.forEach((elm) => {
	elm.addEventListener('click', ()=> {
		elm.classList.toggle('expanded');
	});
})
